var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"back-button"},[_c('a',{staticClass:"link",class:{disabled:_vm.disabled},on:{"click":_vm.onClick}},[_c('i',{staticClass:"far fa-arrow-left"})])])}
var staticRenderFns = []

export { render, staticRenderFns }